module.exports = __webpack_public_path__ + "static/media/choithramsPepsiProductTwo.20ce1ab7.jpg";